/** @jsx jsx */
import { jsx } from '@emotion/core';
import cmsUtils from '../../utils/cmsUtils';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Papa from 'papaparse';
import utils from '../../../utils';
import './style.scss';

export function GoogleDoc(props) {

  const item = props.item;
  const googleDocID = cmsUtils.payload(item, 'GoogleDocID') || '';

  const [jsonData, setJsonData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');
  const inputRef = useRef(null);

  useEffect(() => {
    const fetchGoogleSheet = async () => {
      try {
        const response = await fetch(`${googleDocID}`);
        const text = await response.text();

        Papa.parse(text, {
          header: true, 
          skipEmptyLines: true, 
          complete: (result) => {
            setJsonData(result.data);
          },
        });
      } catch (error) {
        console.error("Fetch Google Sheet error:", error);
      }
    };

    fetchGoogleSheet();
  }, []);

  // useEffect(() => {
  //   if (document.activeElement === inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // });

  // const filteredData = jsonData.filter(row =>
  //   Object.values(row).some(value =>
  //     value.toLowerCase().includes(searchInput.toLowerCase())
  //   )
  // );
  const filteredData = jsonData.filter(row =>
    Object.values(row).some(
      (value) => typeof value === 'string' && value.toLowerCase().includes(searchInput.toLowerCase())
    )
  );

  const handleSort = (column) => {
    const newOrder = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortOrder(newOrder);

    const sortedData = [...filteredData].sort((a, b) => {
      const valA = a[column];
      const valB = b[column];

      if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
        return newOrder === 'asc' ? valA - valB : valB - valA;
      } else {
        return newOrder === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
      }
    });

    setJsonData(sortedData);
  };

  const cssClass = utils.classNames('cms_item', 'google-doc', item.cssClass || item.anchorName || '');

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchInput]);

  const Table = () => {
    if (jsonData.length === 0) {
      return <h3>Loading Data...</h3>
    }

    const firstRow = jsonData[0];

    const keys = [];
    for (let key in firstRow) {
      keys.push(key);
    }

    return (
      <section className={cssClass}>
        {/* search bar */}
        <input
          ref={inputRef}
          type="text"
          placeholder="Search..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className='search-input'
        />

        <table border="1">
          <thead>
            <tr>
              {/* {keys.map((header) => (
                <th key={header}>{header}</th>
              ))} */}
              {keys.map((header) => (
                <th key={header} onClick={() => handleSort(header)} className='thead-element'>
                  {header}
                  <span>
                    {sortColumn === header ? (sortOrder === 'asc' ? ' ↑' : ' ↓') : ' ⇅'}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((row, index) => (
              <tr key={index}>
                {keys.map((header) => (
                  <td key={header}>{row[header] || ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </section>

    );

  }

  return <Table />;

}